import {createApp} from "vue";
import axios from 'axios'
import VueAxios from 'vue-axios'

import AppBezugsquellen from './app.bezugsquellen/bezugsquellen.vue'

const app = createApp(AppBezugsquellen);
app.config.globalProperties.$filters = {
	formatDistance(val)
	{
		let nf = new Intl.NumberFormat(undefined, {style: 'unit', unit: 'kilometer', maximumSignificantDigits: 2});
		return nf.format(val);
	}
};
app.use(VueAxios, axios);
app.provide('dataset', {...document.getElementById('app-bezugsquellen').dataset});
app.mount('#app-bezugsquellen');
